import React, { useState } from 'react'
import D_Resume from '../components/D_Resume'
import D_Passport from '../components/D_Passport'
import D_Bank from '../components/D_Bank'
import Dropdown from 'react-dropdown';
import 'react-dropdown/style.css';
function Details() {
    const [value, setVal] = useState(0)
    function showHide(e) {
        switch (e) {
            case 'Resume': setVal(1); break;
            case 'Passport': setVal(2); break;
            case 'Bank Details': setVal(3); break;
            default: setVal(0)
        }
    }
    function Show() {
        if (value == 1) return <D_Resume />
        else if (value == 2) return <D_Passport />
        else if (value == 3) return <D_Bank />
        else return <></>
    }
    //const [click, setC] = useState(false)
    const options = [
        { value: 'resume', label: 'Resume' },
        { value: 'passport', label: 'Passport' },//
        { value: 'bankdetails', label: 'Bank Details' },//done
    ];
    const [defaultOption, setDef] = useState({ value: 'none', label: 'select' });
    return (
        <div style={{ width: '100%', paddingBottom: '200px' }}>
            <div className='detailsdiv'>
                <span>Details - </span>
                <Dropdown options={options}
                    className='select' controlClassName='myControlClassName'
                    onChange={(e) => { showHide(e.label); setDef(e) }}
                    value={defaultOption} placeholder="select" />
            </div>
            <div className='detail_view'>
                <Show />
            </div>
            {/* <iframe id="frameID" src=
                "http://216.58.221.46/search?q=convert+1+EURO+to+INR&hl=en&lr=lang_en">
            </iframe> */}
        </div>
    )
}
export default Details
